import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "ef00aXXDkVD35kK7hBke7ZR", "DragonHandler", undefined);

import { dragonBones, misc } from "cc";

var DragonHandler = /*#__PURE__*/function () {
  function DragonHandler() {
    _defineProperty(this, "switchSlot", function (armature, slotName, displayIndex, posOffset) {
      if (posOffset === void 0) {
        posOffset = null;
      }

      var slot = armature.getSlot(slotName);

      if (slot && displayIndex >= 0 && displayIndex < slot._displayDatas.length) {
        slot.displayIndex = displayIndex;
        slot.invalidUpdate();
      }
    });

    _defineProperty(this, "switchSkin", function (armature, slotArr, displayIndex) {
      slotArr.forEach(function (slotName) {
        var slot = armature.getSlot(slotName);

        if (slot && displayIndex >= 0 && displayIndex < slot._displayDatas.length) {
          slot.displayIndex = displayIndex;
          slot.displayController = "none";
        }

        slot.invalidUpdate();
      });
    });
  }

  var _proto = DragonHandler.prototype;

  /**
   * 获取目标骨骼的旋转值 - 角度 (遍历父节点)
   * @param dg 龙骨
   * @param aimN 目标骨骼
   */
  _proto.boneAngle = function boneAngle(dg, aimN) {
    var angle = 0;
    var arm = dg.armature();
    var bone = null;

    if (aimN) {
      bone = arm.getBone(aimN);
      var n_p = bone.parent;
      angle = bone.global.rotation;

      while (n_p.name.indexOf("root") == -1) {
        angle += n_p.global.rotation;
        n_p = n_p.parent;
      }

      angle = misc.radiansToDegrees(angle);
    }

    return angle;
  }
  /**
   * 添加龙骨播放一次回调
   * @param dg 龙骨
   * @param curEntry 骨骼状态
   * @param callFunc 播放完毕回调
   */
  ;

  _proto.addCompleteCallBack = function addCompleteCallBack(dg, curEntry, callFunc) {
    dg.once(dragonBones.EventObject.COMPLETE, function (event) {
      callFunc(curEntry.name);
    }, this);
  };

  _createClass(DragonHandler, null, [{
    key: "I",
    get: function get() {
      if (!DragonHandler._I) {
        DragonHandler._I = new DragonHandler();
      }

      return DragonHandler._I;
    }
    /**
     * 切换卡槽显示
     * @param armature 皮肤动画
     * @param slotName 卡槽名字
     * @param displayIndex 显示下标
     */

  }]);

  return DragonHandler;
}();

_defineProperty(DragonHandler, "_I", null);

export { DragonHandler as default };

_cclegacy._RF.pop();